//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/simProviderAccounts/views/main/lan/en';
import createEditSimProviderAccount from 'Modules/simProviderAccounts/views/.components/createEditSimProviderAccount/lan/en';
import deleteSimProviderAccount from 'Modules/simProviderAccounts/views/.components/deleteSimProviderAccount/lan/en';

locales = { ...locales, ...main, ...createEditSimProviderAccount, ...deleteSimProviderAccount };

export default locales;